export default {"src":"/_next/static/media/0x945Facb997494CC2570096c74b5F66A3507330a1.28f5ae19.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};